import { Suspense } from 'react';
import data from '@emoji-mart/data';
import { setDefaultOptions } from 'date-fns';
import { de } from 'date-fns/locale';
import { init } from 'emoji-mart';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { pdfjs } from 'react-pdf';
import { setLicenseKey } from 'survey-core';
import { App } from './app';
import './libs/sentry';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'pdfjs-dist/build/pdf.worker.min.mjs';

// date-fns
setDefaultOptions({ locale: de });
// survey-creator
setLicenseKey(
  'ZDQzOTgxOGMtNGQzMC00YjhhLWFlZmMtYzhiNWM2MzYzMWEyOzE9MjAyNC0xMi0zMA=='
);
// emoji-mart
init({ data });
// PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.min.mjs';
console.warn(pdfjs.GlobalWorkerOptions.workerSrc);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <HelmetProvider>
    <Suspense>
      <App />
    </Suspense>
  </HelmetProvider>
);
